<template>
  <div>
    <div class="row">
      <div class="small-12 medium-4 columns">
        <label>Total super balance <help-icon place="top-right" message="Enter the total for all super accounts you hold."></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :property="Accumulation" @update="setAccumulation($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input filter="currencyDisplay" :property="Accumulation" @change="setAccumulation($event.target.value)"></custom-input>
      </div>
    </div>

    <!-- <div class="row" v-if="isGovernmentWorker">
      <div class="small-12 medium-4 columns">
      <label>Defined Benefit <help-icon place="top-right" message="A Defined Benefit account gives you a package of benefits and uses a formula of a multiple times your salary to calculate your retirement benefit."></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :property="DefinedBenefit" @update="setDefinedBenefit($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input filter="currencyDisplay" :property="DefinedBenefit" @change="setDefinedBenefit($event.target.value)"></custom-input>
      </div>
    </div> -->

    <!-- <div class="row">
      <div class="small-12 medium-4 columns">
        <label>Deferred Retirement Benefit <help-icon message="A deferred retirement benefit is the employer-financed portion of a previous Defined Benefit account. At age 55 your deferred retirement benefit will be transferred to an Accumulation account."></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :property="DeferredRetirementBalance" @update="setDeferredRetirementBalance($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input filter="currencyDisplay" :property="DeferredRetirementBalance" @change="setDeferredRetirementBalance($event.target.value)"></custom-input>
      </div>
    </div> -->

    <!-- <div class="row">
      <div class="small-12 medium-4 columns">
        <label>Other super funds <help-icon place="top-right" message="Enter the total for all super accounts you hold with other funds."></help-icon></label>
      </div>

      <div class="medium-6 columns">
        <slider :property="OtherFunds" @update="setOtherFunds($event.values[0])"></slider>
      </div>

      <div class="small-12 medium-2 columns">
        <custom-input filter="currencyDisplay" :property="OtherFunds" @change="setOtherFunds($event.target.value)"></custom-input>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { EmployerType } from '@/constants';

export default {
  props: {
    modifier: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['inputs', 'inferred']),
    Accumulation() {
      return this.inferred[`Accumulation${this.modifier}`];
    },
    DefinedBenefit() {
      return this.inferred[`DefinedBenefit${this.modifier}`];
    },
    DeferredRetirementBalance() {
      return this.inputs[`DeferredRetirementBalance${this.modifier}`];
    },
    OtherFunds() {
      return this.inferred[`OtherFunds${this.modifier}`];
    },
    isGovernmentWorker() {
      return this.inferred[`EmployerType${this.modifier}`].value === EmployerType.GOVERNMENT;
    },
  },
  methods: {
    ...mapActions([
      'actionAccumulation',
      'actionDefinedBenefit',
      'actionDeferredRetirementBalance',
      'actionOtherFunds',
    ]),
    setAccumulation(value) {
      this.actionAccumulation({ value, modifier: this.modifier });
    },
    setDefinedBenefit(value) {
      this.actionDefinedBenefit({ value, modifier: this.modifier });
    },
    setDeferredRetirementBalance(value) {
      this.actionDeferredRetirementBalance({ value, modifier: this.modifier });
    },
    setOtherFunds(value) {
      this.actionOtherFunds({ value, modifier: this.modifier });
    },
  },
};
</script>
